/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ReducersMapObject, configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import { breadcrumbsSlice } from 'shared/common/AppBreadcrumb/model/slice'

import { authSlice } from 'shared/config/redux/slices/auth'

import { PERSIST_NAVAT_CRM } from '../constants/persistKey'

import { createOrderSlice } from './../../../../modules/Orders/model/createOrderSlice'
import { globalAPI } from './../api/global'
import { StateSchema } from './StateSchema'
import { createReducerManager } from './reducerManager'
import ssrStorage from './ssr-storage'

const persistConfig = {
  key: PERSIST_NAVAT_CRM,
  version: 1,
  storage: ssrStorage,
  whitelist: ['auth', 'breadcrumbs', 'createOrder'],
}

const apiReducers = {
  auth: authSlice,
  breadcrumbs: breadcrumbsSlice,
  createOrder: createOrderSlice,
  [globalAPI.reducerPath]: globalAPI.reducer,
}

const middlewares = [globalAPI.middleware]

export function createReduxStore(
  initialState?: StateSchema,
  asyncReducers?: ReducersMapObject<StateSchema>,
) {
  const rootReducers: ReducersMapObject<StateSchema> = {
    ...asyncReducers,
    ...apiReducers,
  }

  const makeConfiguredStore = () =>
    configureStore({
      reducer: rootReducers,
    })

  const isServer = typeof window === 'undefined'

  if (isServer) {
    return makeConfiguredStore()
  }

  const reducerManager = createReducerManager(rootReducers)

  // @ts-ignore
  const persistedReducer = persistReducer(persistConfig, reducerManager.reduce)

  const store = configureStore<StateSchema>({
    // @ts-ignore
    reducer: persistedReducer,
    devTools: true,
    preloadedState: initialState,
    // @ts-ignore
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(middlewares),
  })
  // @ts-ignore
  store.reducerManager = reducerManager

  return store
}
